import {Injectable} from "@angular/core";
import {MatSnackBar} from '@angular/material/snack-bar';
import {CookieSnackbarComponent, CookieSnackbarData, ICookieSnackbarAction} from '../components/cookie-snackbar/cookie-snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class CookiePolicyService implements ICookieSnackbarAction {
  private cookieName: string = 'cookie';

  constructor(private _snackBar: MatSnackBar) {
  }

  checkAndShow(): void {
    if(localStorage.getItem(this.cookieName) == '1') {
      return;
    }

    const snackbarData = new CookieSnackbarData();
    snackbarData.cookieService = this;

    const snackbarRef = this._snackBar.openFromComponent(CookieSnackbarComponent, {
      panelClass: ['cookie', 'cookie-snackbar-container'],
      data: snackbarData,
    });
  }

  accept() {
    localStorage.setItem(this.cookieName, '1');
    this._snackBar.dismiss();
  }
}
